import { useEffect, useState } from "react";
import axios from "../../api/axios";
import "../../styles/theme-dark.css";

/* ============================
   COMPONENTES AUXILIARES
============================ */
function PuntosAnimados({ texto }) {
  const [puntos, setPuntos] = useState("");

  useEffect(() => {
    const i = setInterval(() => {
      setPuntos((p) => (p.length >= 3 ? "" : p + "."));
    }, 400);
    return () => clearInterval(i);
  }, []);

  return <span>{texto}{puntos}</span>;
}

function EstadoGuardado({ guardando }) {
  return (
    <div
      style={{
        marginTop: 6,
        fontSize: 12,
        color: guardando ? "#facc15" : "#7CFC9A",
        height: 16,
      }}
    >
      {guardando ? <PuntosAnimados texto="Guardando" /> : "Guardado"}
    </div>
  );
}

/* ============================
   COMPONENTE PRINCIPAL
============================ */
export default function RellenarInformeInstalacion({ instalacionId, volver }) {
  const [loading, setLoading] = useState(true);
  const [checklist, setChecklist] = useState(null);
  const [bloquesConItems, setBloquesConItems] = useState([]);
  const [loadingBloques, setLoadingBloques] = useState(false);

  const [observaciones, setObservaciones] = useState("");
  const [guardandoItem, setGuardandoItem] = useState(null);
  const [guardandoGlobal, setGuardandoGlobal] = useState(false);
  const [mostrarModalEnviar, setMostrarModalEnviar] = useState(false);
const [emailEnvio, setEmailEnvio] = useState("");


    function enviarAlCliente() {
  setEmailEnvio("");

  setMostrarModalEnviar(true);
}

async function confirmarEnvioCliente() {
  try {
    if (!emailEnvio.trim()) {
      alert("Introduce un email válido");
      return;
    }

    const res = await axios.post(
      `/instalaciones/${instalacionId}/enviar-firma`,
      { email: emailEnvio }
    );

    if (res.data?.success) {
  setMostrarModalEnviar(false);

  // 🔒 Cerrar informe y volver a técnicos
  if (typeof volver === "function") {
    volver();
  }
}

  } catch (e) {
    console.error("Error enviando correo:", e);
    alert(
      e.response?.data?.error ||
      "Error enviando el correo al cliente"
    );
  }
}


  /* ============================
     AUTOSAVE OBSERVACIONES
  ============================ */
  useEffect(() => {
    if (!checklist) return;

    setGuardandoGlobal(true);

    const timeout = setTimeout(async () => {
      try {
        await axios.put(
          `/checklists/instalacion/${instalacionId}/observaciones`,
          { observaciones }
        );
      } catch (e) {
        console.error("Error guardando observaciones", e);
      } finally {
        setGuardandoGlobal(false);
      }
    }, 800);

    return () => clearTimeout(timeout);
  }, [observaciones]);

  /* ============================
     CARGA CHECKLIST
  ============================ */
  useEffect(() => {
    async function cargarTodo() {
      try {
        setLoading(true);

        const res = await axios.get(`/checklists/instalacion/${instalacionId}`);
        const data = res.data?.checklist || res.data;

        if (!data) throw new Error("Checklist no encontrado");

        setChecklist(data);
        setObservaciones(data.observaciones || "");

        await cargarBloquesConItems(data.items || []);
      } catch (e) {
        console.error(e);
        alert("Error cargando informe");
      } finally {
        setLoading(false);
      }
    }

    cargarTodo();
  }, [instalacionId]);

  /* ============================
     BLOQUES + ITEMS
  ============================ */
  async function cargarBloquesConItems(checklistItems) {
    try {
      setLoadingBloques(true);

      const response = await fetch("/api/bloques");
      const data = await response.json();
      const bloques = data.blocks || data || [];

      const itemIds = checklistItems.map((it) => it.itemId);

      const bloquesFiltrados = bloques
        .map((bloque) => {
          const itemsFiltrados = (bloque.items || []).filter((item) =>
            itemIds.includes(item.id)
          );

          if (!itemsFiltrados.length) return null;

          return {
            id: bloque.id,
            nombre: bloque.nombre,
            items: itemsFiltrados.map((item) => {
              const it = checklistItems.find((x) => x.itemId === item.id);
              return {
                id: it.id,
                texto: item.texto,
                marcado: !!it.marcado,
              };
            }),
          };
        })
        .filter(Boolean);

      setBloquesConItems(bloquesFiltrados);
    } catch (e) {
      console.error("Error cargando bloques", e);
    } finally {
      setLoadingBloques(false);
    }
  }

  /* ============================
     TOGGLE ITEM
  ============================ */
  async function toggleItem(id, valorActual) {
    try {
      setGuardandoItem(id);
      setGuardandoGlobal(true);

      await axios.put(
        `/checklists/instalacion/${instalacionId}/items/${id}`,
        { marcado: !valorActual }
      );

      setChecklist((prev) => ({
        ...prev,
        items: prev.items.map((it) =>
          it.id === id ? { ...it, marcado: !valorActual } : it
        ),
      }));

      setBloquesConItems((prev) =>
        prev.map((bloque) => ({
          ...bloque,
          items: bloque.items.map((item) =>
            item.id === id ? { ...item, marcado: !valorActual } : item
          ),
        }))
      );
    } catch (e) {
      console.error(e);
      alert("Error guardando ítem");
    } finally {
      setGuardandoItem(null);
      setGuardandoGlobal(false);
    }
  }

  /* ============================
     RENDER
  ============================ */
  if (loading) {
    return (
      <div className="page-dark" style={{ padding: 40, textAlign: "center" }}>
        Cargando informe…
      </div>
    );
  }

  return (
    <div className="page-dark" style={{ maxWidth: 1200, margin: "0 auto", padding: 20 }}>
      {/* HEADER */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <div style={{ fontWeight: 700 }}>COREX3</div>

        <div style={{ textAlign: "center" }}>
          <h2 style={{ margin: 0 }}>Informe de instalación</h2>
          <div style={{ fontSize: 12, color: "#4dabf7" }}>
            Items: {checklist.items.length} · Bloques: {bloquesConItems.length} · Estado: {checklist.estado}
          </div>
          <EstadoGuardado guardando={guardandoGlobal} />
        </div>

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button className="glass-btn" onClick={volver}>
            ← Volver
          </button>
          <button className="glass-btn" onClick={enviarAlCliente}>
  ✉ Enviar al cliente
</button>

        </div>
      </div>

      {/* BLOQUES */}
      {loadingBloques ? (
        <div style={{ textAlign: "center" }}>Cargando bloques…</div>
      ) : (
        bloquesConItems.map((bloque) => (
          <div key={bloque.id} style={{ marginBottom: 26 }}>
            <h4 style={{ color: "#4dabf7", marginBottom: 10 }}>
              {bloque.nombre} ({bloque.items.length})
            </h4>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 8 }}>
              {bloque.items.map((item) => (
                <div
                  key={item.id}
                  onClick={() => toggleItem(item.id, item.marcado)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 12px",
                    background: "rgba(255,255,255,0.04)",
                    borderRadius: 8,
                    cursor: "pointer",
                  }}
                >
                  {/* TEXTO */}
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 600,
                      color: item.marcado ? "#9ca3af" : "#ffffff",
                      textDecoration: item.marcado ? "line-through" : "none",
                      paddingRight: 12,
                    }}
                  >
                    {item.texto}
                  </div>

                  {/* CHECK */}
                  <input
                    type="checkbox"
                    checked={item.marcado}
                    readOnly
                    style={{
                      width: 14,
                      height: 14,
                      accentColor: "#4dabf7",
                      cursor: "pointer",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))
      )}

      {/* OBSERVACIONES */}
      <div
        style={{
          marginTop: 30,
          padding: 16,
          background: "rgba(255,255,255,0.04)",
          borderRadius: 10,
        }}
      >
        <h4>Observaciones finales</h4>
        <textarea
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
          placeholder="Escribe aquí las observaciones…"
          style={{
            width: "100%",
            minHeight: 90,
            padding: 10,
            fontSize: 14,
            background: "rgba(0,0,0,0.4)",
            color: "white",
            borderRadius: 6,
            border: "1px solid rgba(255,255,255,0.15)",
          }}
        />
      </div>
{/* MODAL ENVIAR AL CLIENTE */}
{mostrarModalEnviar && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.55)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: 16,
    }}
  >
    <div
      style={{
        width: "min(520px, 100%)",
        background: "#0b1220",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: 12,
        padding: 16,
      }}
    >
      <h3 style={{ marginTop: 0, marginBottom: 12 }}>
        Enviar informe al cliente
      </h3>

      <div style={{ fontSize: 12, opacity: 0.85, marginBottom: 10 }}>
        El email se puede modificar aquí sin cambiar los datos del cliente.
      </div>

      <label style={{ fontSize: 12, opacity: 0.85 }}>Email del cliente</label>
      <input
        type="email"
        value={emailEnvio}
        onChange={(e) => setEmailEnvio(e.target.value)}
        placeholder="cliente@empresa.com"
        style={{
          width: "100%",
          padding: 10,
          marginTop: 6,
          borderRadius: 8,
          border: "1px solid rgba(255,255,255,0.15)",
          background: "rgba(255,255,255,0.06)",
          color: "white",
        }}
      />

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 14 }}>
        <button
          className="glass-btn"
          onClick={() => setMostrarModalEnviar(false)}
        >
          Cancelar
        </button>

        <button
          className="glass-btn"
          onClick={confirmarEnvioCliente}
        >
          Enviar
        </button>
      </div>
    </div>
  </div>
)}




    </div>
  );
}

